import React from 'react';
import { createGlobalStyle } from 'styled-components';
import HomePage from './components/Home/HomePage';
import './i18n'; // Import i18n configuration

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Montserrat', sans-serif;
  }
  
  body {
    background-color: #000;
    overflow-x: hidden;
  }

  html {
    scroll-behavior: smooth;
  }

  /* For Arabic text alignment */
  [lang="ar"] {
    direction: rtl;
    text-align: right;
  }
`;

function App() {
  return (
    <>
      <GlobalStyle />
      <HomePage />
    </>
  );
}

export default App;
